
const SectionHeader = ({ title, icon }) => (
    <div className="flex items-center gap-2 mb-4">
        <span className="text-lg">{icon}</span>
        <h3 className="text-sm font-bold text-slate-500 uppercase tracking-wide">{title}</h3>
    </div>
);

export default SectionHeader